<template>
  <span>
    <crud-layout-search
              ref='crudLayoutSearch'
              :name="$gettext('ROUTE_DETAILING_SEARCH')"
              :interface="'routeDetailing.pesquisarRouteDetailing'"
              :id="id"
              clean-layout>

    </crud-layout-search>
    <jt-docs-viewer
      ref="reportModal"
      pdf
      :src="src"
      @hide="closeDoc"
    />
    </span>
  </template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtDocs } from 'jtech-webcomps'
import { repository } from 'jtech'

const { CrudLayoutSearch } = JtCrud
const { JtDocsViewer } = JtDocs

  @Component({
    name: 'RouteDetailingPageSearch',
    components: { CrudLayoutSearch, JtDocsViewer }
  })
class RouteDetailingPageSearch extends Vue {
  nmInterface = 'routeDetailing.pesquisarRouteDetailing'
  datatable = null
  src = null
  dadosTelaFromRepository = []
  reportTitle = this.$gettext('PRINT_ROUTE_DETAILING')
  nmInterfaceReport = 'routeDetailingReport.routeDetailingReport'

  async mounted () {
    this.$refs.crudLayoutSearch.onButton('icPrint', this.onPrint)
    await this.loaded()
  }

  async updated () {
    if (!this.datatable) { await this.loaded() }
  }

  async onPrint ({ params }) {
    const resolveLogicResult = await repository.resolveLogic(
      this.nmInterfaceReport,
      { cdRelatorio: this.reportTitle, relFormatoRelatorio: 1, relFormaGeracao: 1, routeDetailing: params.id, ...params }
    )

    await this.__whenGenerationFormatIsOnline(resolveLogicResult)
  }

  async __whenGenerationFormatIsOnline ({ nmArquivo }) {
    try {
      const result = await repository.downloadFile(
        nmArquivo,
        'pdf',
        '',
        'application/pdf'
      )
      this.src = URL.createObjectURL(result)
      this.$nextTick(() => {
        this.$refs.reportModal.show()
      })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async loaded () {
    this.datatable = await repository.resolveDatatable(this.nmInterface)
  }

  actionButton (button, params) {
    if (button.name == 'icAlterar') {
      this.$emit('action-button', button, params, this)
    } else {
      this.$emit('action-button', button, this.$refs.jtDataTable.selected, this)
    }
  }
  }
export default RouteDetailingPageSearch
</script>
